/** Gedeelde layout-shell voor alle werknemer-pages (mobile-first), in de huisstijl.
 *
 *  Dit is de strengste omgeving van de app: iemand vult hier op zijn eigen telefoon
 *  gezondheidsvragen in, in werktijd, over zijn eigen lichaam. Daarom:
 *  — de inhoud staat in één kolom van maximaal --shell-max breed;
 *  — de kop is het woordmerk, verder niets dat afleidt;
 *  — de voortgangsbalk gebruikt de actiekleur, nooit een betekeniskleur.
 *
 *  De klasse `fulkra` zet de huisstijl aan voor alles wat hieronder hangt.
 */
import React from "react";

export function PageShell({ children, title }) {
  return (
    <div className="fulkra" style={{ minHeight: "100vh", background: "var(--surface-page)", color: "var(--text-strong)" }}>
      <header style={{ borderBottom: "1px solid var(--border-subtle)", background: "var(--wit)" }} data-testid="motera-header">
        <div
          style={{
            margin: "0 auto", maxWidth: "var(--shell-max)", display: "flex",
            alignItems: "baseline", justifyContent: "space-between", gap: "var(--ruimte-5)",
            padding: "var(--ruimte-5) var(--ruimte-6)",
          }}
        >
          <span
            data-testid="motera-logo"
            style={{
              fontFamily: "var(--font-kop)", fontWeight: "var(--fw-semi)", fontSize: "var(--fs-h3)",
              letterSpacing: "var(--ls-kop)", color: "var(--text-strong)",
            }}
          >
            Fulkra Works
          </span>
          {title && <span style={{ fontSize: "var(--fs-sm)", color: "var(--text-soft)" }}>{title}</span>}
        </div>
      </header>

      <main
        data-testid="page-main"
        style={{ margin: "0 auto", maxWidth: "var(--shell-max)", padding: "var(--ruimte-8) var(--ruimte-6) var(--ruimte-11)" }}
      >
        {children}
      </main>

      <footer
        style={{
          margin: "0 auto", maxWidth: "var(--shell-max)",
          padding: "0 var(--ruimte-6) var(--ruimte-11)",
          textAlign: "center", fontSize: "var(--fs-xs)", color: "var(--text-soft)",
        }}
      >
        Bij vragen: <a href="mailto:info@fulkraworks.nl" style={{ color: "var(--text-action)" }}>info@fulkraworks.nl</a>
      </footer>
    </div>
  );
}

export function ProgressBar({ current, total }) {
  const pct = Math.round((current / total) * 100);
  return (
    <div style={{ marginBottom: "var(--ruimte-8)" }} aria-label={`Stap ${current} van ${total}`} data-testid="progress-bar">
      <div
        style={{
          marginBottom: "var(--ruimte-3)", display: "flex", alignItems: "center",
          justifyContent: "space-between", fontSize: "var(--fs-xs)", color: "var(--text-soft)",
        }}
      >
        <span>Stap {current} van {total}</span>
        <span style={{ fontVariantNumeric: "tabular-nums" }}>{pct}%</span>
      </div>
      <div
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
        style={{ height: 8, width: "100%", overflow: "hidden", borderRadius: "var(--radius-pil)", background: "var(--neutraal-200)" }}
      >
        <div style={{ height: "100%", width: `${pct}%`, background: "var(--actie)", transition: "width var(--duur-traag) var(--ease-standaard)" }} />
      </div>
    </div>
  );
}

export function ErrorBanner({ error }) {
  if (!error) return null;
  return (
    <div
      role="alert"
      data-testid="error-banner"
      style={{
        marginBottom: "var(--ruimte-6)", borderRadius: "var(--radius)",
        border: "1px solid var(--alarm-rand)", background: "var(--alarm-zacht)",
        padding: "var(--ruimte-5)", fontSize: "var(--fs-body)", color: "var(--text-alarm)",
      }}
    >
      {error.message}
    </div>
  );
}
